import { Button } from 'app/components/design-system-components'
import { renbondApplyNowURLWithParams } from 'app/Integrations/components/RentBond/config'
import type { RentBondPreApprovedButtonProps } from 'app/Integrations/components/RentBond/types'
import { useGTMTracking } from 'app/utils/hooks/useGTMTracking'

function RentBondPreApprovedButton({
  className = '',
  linkParam = '',
}: RentBondPreApprovedButtonProps) {
  const RENTBOND_URL = renbondApplyNowURLWithParams(linkParam)
  const {
    trackingProps: { className: trackingClassName, onClick },
  } = useGTMTracking(className, RENTBOND_URL)

  return (
    <Button
      p={4}
      sizeVariant="large"
      width="100%"
      className={trackingClassName}
      onClick={onClick}
    >
      Apply now
    </Button>
  )
}

export default RentBondPreApprovedButton
